<template>
    <input :class="[className, { 'is-loading': isLoading }]" :type="type" v-model="displayMessage" :disabled="isDisabled && !isLoading" @click.prevent="doAction">
</template>

<script>
export default {
    name: 'ButtonAction',
    data() {
        return {
        };
    },
    props: {
        message: {
            type: String,
            default: "Продолжить"
        },
        type: String,
        className: String,
        isDisabled: Boolean,
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayMessage: {
            get() {
                return this.isLoading ? '' : this.message;
            },
            set() {}
        }
    },
    methods: {
        doAction() {
            if (this.isLoading) return;
            this.$emit('buttonAction')
        },
    },
};
</script>

<style scoped lang="scss">
.main-action-btn {
    display: block;
    width: 100%;
    max-width: 288px;
    padding: 14px 0 15px;
    background: #22B491;
    border-radius: 8px;
    border: none;
    font-family: Gilroy;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: normal;
    color: #fff;
    text-align: center;
    cursor: pointer;

    &.main-action-btn-gradient {
        background: radial-gradient(53.82% 1882.37% at 60.59% 58.33%,
                #2f80ed 0%,
                #c26bd9 100%);
    }


    &.main-action-btn-grey {
        background: #BDBDBD;
    }

    &.main-action-btn-grey.hide {
        display: none;
    }

    &.main-action-btn-outline {
        color: #828282;
        background: #fff;
        border: 1px solid #828282;
    }

}

.main-action-btn-small {
    display: block;
    width: 208px;
    height: 40px;
    padding: 11px 0 10px;
    background: #22B491;
    border: none;
    border-radius: 8px;
    font-family: Gilroy;
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;
    color: #fff;
    text-align: center;
    cursor: pointer;
}

.enter-form-error {
    .main-action-btn {
        background: #BDBDBD;
    }
}

.input-containers-error {
    .main-action-btn {
        background: #BDBDBD;
    }
}

.main-action-btn.main-action-btn-disabled {
    background: #BDBDBD;
}

.main-action-btn.is-loading,
.main-action-btn-small.is-loading {
    position: relative;
    color: transparent !important;
    cursor: wait;
    pointer-events: none;
    background: url('../../../assets/img/loading.svg') center / 24px 24px no-repeat #22B491 !important;
}

._profile-mode-inner.cancel-sub {
    .main-action-btn {
        margin-bottom: 15px;
    }
}

@media screen and (max-width: 725px) {
    .main-action-btn {
        width: 100%;
    }
}
</style>
